module.exports = __webpack_public_path__ + "img/cart-off.81633d66.svg";